/**
 * Specifies the transaction type of the risk limit check request.
 * tag: 2320
 * @readonly
 * @enum {number} (int)
 */
export enum RiskLimitCheckTransType {
  /** New */
  New = 0,
  /** Cancel */
  Cancel = 1,
  /** Replace */
  Replace = 2,
}
